// polyfill
import '@babel/polyfill';
import 'react-app-polyfill/ie9';
